import { getFolderById } from './collectionFolders';
import { folderPageFields } from './folderPageFields';

/** Build collection tab fields from a collection record in sidebar state. */
export function hydrateCollectionTabFromRecord(collection) {
  const settings = collection?.settings || {};
  const variables =
    collection?.variable_scopes?.collection_variables ??
    settings.collection_variables ??
    [];

  return {
    collectionId: collection.id,
    name: collection.name || 'Collection',
    section: 'docs',
    documentation: settings.documentation || '',
    auth: settings.collection_auth || { type: 'noauth' },
    variables: variables.map((v) => ({ ...v })),
    // Collection scripts live on `settings` (the importers put them there, and
    // utils/scriptChain reads them from there under Run collection).
    preRequestScript: typeof settings.preRequestScript === 'string' ? settings.preRequestScript : '',
    testScript: typeof settings.testScript === 'string' ? settings.testScript : '',
    hasUnsavedChanges: false,
  };
}

/**
 * A FOLDER page tab (owner D1, 28.09.2026) is a collection tab that also names
 * a `folderId`: same strip, same persistence, same editor shell. Its fields
 * come from the folder record (utils/folderPageFields).
 */
export function hydrateFolderTabFromRecord(collection, folderId) {
  const folder = getFolderById(collection, folderId);
  if (!folder) return null;
  const fields = folderPageFields(folder);
  return {
    collectionId: collection.id,
    folderId: String(folder.id),
    name: folder.name || 'Folder',
    section: 'docs',
    documentation: fields.documentation,
    auth: fields.auth,
    variables: fields.variables.map((v) => ({ ...v })),
    preRequestScript: fields.preRequestScript,
    testScript: fields.testScript,
    hasUnsavedChanges: false,
  };
}

/** True for a folder page tab. */
export function isFolderTab(tab) {
  return tab?.folderId != null && tab.folderId !== '';
}

/** Does `tab` show exactly this collection page (`folderId` null) or this folder page? */
export function isTabFor(tab, collectionId, folderId = null) {
  if (String(tab?.collectionId) !== String(collectionId)) return false;
  if (folderId == null) return !isFolderTab(tab);
  return isFolderTab(tab) && String(tab.folderId) === String(folderId);
}

export function mergeCollectionSettings(existing = {}, patch = {}) {
  return {
    ...existing,
    ...patch,
  };
}

export function stripVariableRowIds(variables) {
  return (variables || [])
    .map(({ _id, ...row }) => row)
    .filter((r) => String(r.key ?? '').trim() !== '' || String(r.value ?? '').trim() !== '');
}
